
import Vue from "vue"
import type { CustomEvent } from "@/types/api/event"
import type { EventRequest } from "@/types/api/requests"
import { VK_APP_ENABLED, isVkAppAllowed } from "@/utils/vk-app"
import { MFM_EVENT_ALIAS } from "@/utils/mfm"

export default Vue.extend({
  data: () => ({
    event: null as Nullable<CustomEvent>,
    request: null as Nullable<EventRequest>,
  }),

  async fetch () {
    this.event = null
    this.request = null

    if (!VK_APP_ENABLED || this.eventAlias !== MFM_EVENT_ALIAS) return

    await Promise.all([this.fetchEvent(), this.fetchRequest()])
  },

  computed: {
    eventAlias (): string {
      return this.$route.params.eventAlias || ""
    },

    isVisible (): boolean {
      return isVkAppAllowed(
        this.eventAlias,
        this.request?.state,
        this.request?.status?.alias,
      )
    },

    logoUrl (): string {
      let logos = [
        this.event?.logo?.url,
        this.event?.logoEn?.url,
      ]

      if (this.$i18n.locale !== "ru")
        logos = logos.reverse()

      return logos.filter(Boolean)[0] || ""
    },
  },

  watch: {
    eventAlias () {
      this.$fetch()
    },
  },

  methods: {
    async fetchEvent () {
      const [res, err] = await this.$api.event.getEventData()

      if (err) {
        console.error(err)
        return
      }

      this.event = res || null
    },

    async fetchRequest () {
      const [res, err] =
        await this.$api.requests.listMyEventParticipationForDetails(
          [{ name: "event.alias", value: this.eventAlias }],
          { params: { event: this.$config.event } },
        )

      if (err) {
        console.error(err)
        return
      }

      this.request = res?.items?.[0] || null
    },
  },
})
